export default "__VITE_ASSET__Bp7RumFB__"